export enum SettingsSection {
  Machine = 'Machine',
  Interface = 'Interface',
  User = 'User',
  Accessories = 'Accessories',
}

export enum MachineSettingsTabKey {
  General = 'General',
  Projector = 'Projector',
  Firing = 'Firing',
  TrackingDevice = 'Tracking Device',
  Maintenance = 'Maintenance',
  Switch = 'Switch Machine',
}

export enum UserSettingsTabKey {
  ReassignPitchLists = 'Reassign Pitch Lists',
  TeamAdmins = 'Team Admins',
}
